document.addEventListener('DOMContentLoaded', function() {
    const nav = document.querySelector('.js-tdv-nav');
    const items = document.querySelectorAll('.js-tdv-item');
    if (!nav) return;
    nav.addEventListener('click', function(e) {
        if (e.target.matches('.js-tdv-tab')) {
            const tab = e.target.getAttribute('data-tab');
            nav.querySelectorAll('.js-tdv-tab').forEach(btn => btn.classList.remove('active'));
            e.target.classList.add('active');
            items.forEach(item => {
                if (item.getAttribute('data-tab') === tab) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }
            });
        }
    });
});